



























































import { Input as formInput, Select as FormSelect } from '@/components/form';
import { OptionsType } from '@/pages/profile/views/general/types';
import { and, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
export default {
  name: 'ModalEssia',
  components: { FormSelect, formInput },
  mixins: [validationMixin],
  props: {
    errors: {},
  },
  validations() {
    const result: any = {
      municipality_id: {
        isNotEmpty: and((value, context) => {
          if (
            context.$store.state.regionProfile.regionId == context.region_id
          ) {
            return !!context.municipality_id;
          } else {
            return true;
          }
        }),
      },
      region_id: { required },
      edu_level_id: { required, and: and((value: any) => value !== 0) },
    };

    if (this.need_phone) {
      result.phone = {
        required,
        and: and((value) => /^\([19]\d\d\)\ \d\d\d\-\d\d\-\d\d$/.test(value)),
      };
    } else {
      result.phone = {
        and: and(
          (value) => /^\([19]\d\d\)\ \d\d\d\-\d\d\-\d\d$/.test(value) || !value
        ),
      };
    }
    return result;
  },
  data() {
    return {
      municipality_id: '',
      region_id: this.$store.state.regionProfile.regionId || '',
      edu_level_id: '',
      phone: '',
      uuid: '',
      need_phone: false,
    };
  },
  watch: {
    region_id() {
      this.$v.municipality_id.$touch();
    },
    $route: {
      immediate: true,
      handler() {
        const uuid = this.$route.query.uuid;
        if (uuid) {
          this.uuid = uuid;
        }
        const req = this.$route.query.need_phone;
        if (req) {
          this.need_phone = req === 'true';
        }
      },
    },
    submitData: {
      handler() {
        const submitData: any = {
          submitData: {
            municipality_id: this.municipality_id,
            region_id: this.region_id,
            edu_level_id: this.edu_level_id,
            phone: this.phone ? this.phone : undefined,
            uuid: this.uuid,
            need_phone: this.need_phone,
          },
          $v: this.$v,
        };
        this.$emit('input', submitData);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    isDisableMunicipality() {
      const isDisable = !(
        this.$store.state.regionProfile.regionId > 0 &&
        +this.$store.state.regionProfile.regionId === +this.region_id
      );
      if (isDisable) this.municipality_id = '';
      return isDisable;
    },
    getErrors() {
      const ret: any = {};
      (this.errors || []).forEach((error: any) => {
        ret[error['attribute']] = error.msg;
      });
      return ret;
    },
    submitData() {
      return {
        municipality_id: this.municipality_id,
        region_id: this.region_id,
        edu_level_id: this.edu_level_id,
        phone: this.phone,
        uuid: this.uuid,
        need_phone: this.need_phone,
      };
    },
    routeHash() {
      return this.$route.hash ? this.$route.hash.substring(1) : '';
    },
    municipalitetDict() {
      return this.$store.state.municipalities.map((item) => ({
        text: item.name,
        value: item.id,
      }));
    },
    regionsDict() {
      return this.$store.state.regionsDict.map((m) => ({
        value: m.id,
        text: m.name,
      }));
    },
    levelOptions() {
      const { eduLevels } = this.$store.state;
      return eduLevels
        ? [
            ...eduLevels.map(({ name, id }: OptionsType) => ({
              text: name,
              value: id,
            })),
          ]
        : [];
    },
    phoneMask() {
      return [
        '(',
        /[1-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ];
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modalEssia/ModalEssia.vue